import { Surface } from '@vst/beam';

import { ScheduleInstallationForm } from './schedule-installation-form';

const ScheduleInstall = (): JSX.Element => {
  return (
    <Surface
      style={{ flex: 1 }}
      variant="secondary"
      data-cy="schedule-installation-page"
    >
      <ScheduleInstallationForm />
    </Surface>
  );
};

export default ScheduleInstall;
